import script from "./EditFormula.vue?vue&type=script&setup=true&lang=js"
export * from "./EditFormula.vue?vue&type=script&setup=true&lang=js"

import "./EditFormula.vue?vue&type=style&index=0&id=60001f54&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60001f54"]])

export default __exports__